var _defs, _rect, _rect2, _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgTealGlow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(640 360) rotate(90) scale(500 780)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021118"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panel",
    x1: 104,
    y1: 72,
    x2: 1176,
    y2: 648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3B48",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#072330",
    stopOpacity: 0.42
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 72,
    width: 1072,
    height: 576,
    rx: 44,
    fill: "url(#panel)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 596,
    r: 220,
    fill: "#2DD4BF",
    fillOpacity: 0.18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1090,
    cy: 130,
    r: 180,
    fill: "#14B8A6",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 560C190 454 376 428 558 482C740 536 980 522 1280 402V720H0V560Z",
    fill: "#0F766E",
    fillOpacity: 0.28
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 148C234 72 396 60 562 112",
    stroke: "#5EEAD4",
    strokeOpacity: 0.42,
    strokeWidth: 18,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTealGlow);
export default __webpack_public_path__ + "static/media/bg-teal-glow.32ea6f08841a61bce4e026167da7a04e.svg";
export { ForwardRef as ReactComponent };